import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Input, Nav, NavItem, NavLink, Row } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

function ListItem(props) {
  const { values, inputs } = props;
  const isSelected = inputs[0].value === values[0] && inputs[1].value === values[1];

  return (
    <NavItem
      active={isSelected}
      onClick={e => {
        props.inputs[0].onChange(props.values[0]);
        props.inputs[1].onChange(props.values[1]);
      }}
    >
      <NavLink className={props.linkClassName} href="#" active={isSelected}>
        {props.children}
      </NavLink>
    </NavItem>
  );
}

class DateInput extends Component {
  render() {
    return <Input {...this.props} style={{ width: '100%' }} />;
  }
}

class DateRangeFilter extends Component {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const { names, labels, showSuggestions, tabIndex } = this.props;

    const listItemProps = {
      linkClassName: `${BS.pt1} ${BS.pb1}`,
      inputs: [this.props[names[0]].input, this.props[names[1]].input]
    };

    return (
      <div>
        {showSuggestions && (
          <div>
            <Nav horizontal="space-between" className={BS.navSelect}>
              <ListItem
                {...listItemProps}
                values={[moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]}
              >
                Today
              </ListItem>
              <ListItem
                {...listItemProps}
                values={[
                  moment().format('YYYY-MM-DD'),
                  moment().add(7, 'day').format('YYYY-MM-DD')
                ]}
              >
                Next 7 Days
              </ListItem>
              <ListItem
                {...listItemProps}
                values={[
                  moment().format('YYYY-MM-DD'),
                  moment().add(14, 'day').format('YYYY-MM-DD')
                ]}
              >
                Next 14 Days
              </ListItem>
            </Nav>
            <div className={`${BS.mt2} ${BS.mb2} ${BS.textCenter}`}>Or</div>
          </div>
        )}
        <Row>
          {names.map((name, i) => {
            const field = this.props[name];
            const { value, ...inputProps } = field.input;
            const { minDate } = this.props;
            const maxDate = undefined;

            return (
              <Col key={i} xs={6} className={i > 0 ? BS.colDivider : undefined}>
                <DatePicker
                  selected={value ? moment(value, 'YYYY-MM-DD') : undefined}
                  placeholderText={labels[i]}
                  {...inputProps}
                  tabIndex={tabIndex ? tabIndex + i : tabIndex}
                  customInput={<DateInput />}
                  selectsStart={i === 0}
                  selectsEnd={i !== 0}
                  minDate={minDate && moment(minDate)}
                  maxDate={maxDate && moment(maxDate)}
                  onChange={date => {
                    inputProps.onChange(date ? date.format('YYYY-MM-DD') : '');
                  }}
                  dateFormat="YYYY-MM-DD"
                />
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
}

export default DateRangeFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/daterange-filter.js